import React from "react";
import { Badge } from "./Badge";
import { STATUS_LABEL as APP_STATUS_LABEL } from "../admin/AdminUI";

/**
 * Statuslabel in de huisstijl.
 *
 * De teksten komen uit `AdminUI.jsx` — dat is en blijft de enige plek waar een status
 * zijn Nederlandse naam krijgt. Het ontwerp levert dezelfde lijst nog een keer mee; die
 * hier overnemen zou betekenen dat één hernoemde status op twee plekken bijgewerkt moet
 * worden, en dat gaat een keer mis.
 *
 * Tot 23-08-2026 stond hier een aanvullijst met zeven standen die de app nog niet
 * benoemde. Die zijn naar `AdminUI.jsx` verhuisd toen bleek dat het keuzemenu op de
 * bestelpagina gewoon `in_productie` liet zien — die lijst werd daar niet gelezen. Eén
 * lijst is er dus één te onthouden, en de kans dat een scherm databasetaal toont is weg.
 */
export const STATUS_LABEL = APP_STATUS_LABEL;

/** Welke toon hoort bij welke status. Betekeniskleuren zijn nooit decoratief:
    rood staat uitsluitend op iets dat mis is, groen op iets dat afgerond is. */
const TOON = {
  aangemeld: "neutraal", uitgenodigd: "aandacht", baseline_voltooid: "actie", gepland: "actie",
  aangemeten: "actie", klaar_om_te_bestellen: "aandacht", besteld: "aandacht",
  binnengekomen: "actie", verzonden: "actie", geleverd: "positief",
  week4_voltooid: "actie", week12_voltooid: "actie", afgerond: "positief", gepauzeerd: "neutraal",
  opgezegd: "alarm", no_show: "alarm", geanonymiseerd: "neutraal", voorgesteld: "aandacht",
  voltooid: "positief", actief: "positief", beeindigd: "alarm", pending: "neutraal",
  sending: "actie", geopend: "positief", gefaald: "alarm", overgeslagen: "aandacht",
  bounced: "alarm", complained: "alarm", open: "aandacht", geannuleerd: "alarm",
  bevestigd: "positief", afgehandeld: "positief", in_productie: "actie", foutief: "alarm",
  herbesteld: "aandacht", in_uitvoering: "actie", verzet: "aandacht",
};

export function StatusBadge({ value, label, ...rest }) {
  if (!value) return <span style={{ color: "var(--text-soft)", fontSize: "var(--fs-xs)" }}>—</span>;
  return <Badge tone={TOON[value] || "neutraal"} pill {...rest}>{label || STATUS_LABEL[value] || value}</Badge>;
}
